// extracted by mini-css-extract-plugin
export default {"container":"style_container__Mpj+2","information":"style_information__rMKPY","infoContractType":"style_infoContractType__mh5Nn"};